module.exports = __webpack_public_path__ + "img/upload-id.530e6112.jpg";